import { Notification } from 'element-ui'

export default function(value) {
  if (value) {
    const el = document.createElement('textarea')

    el.value = value
    document.body.appendChild(el)

    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)

    Notification({
      type: 'success',
      title: 'Copied to Clipboard',
    })
  }
}
